// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parseBoolean } from "@awc/XDL/Utilities";
import { Cart } from "@insite/client-framework/Services/CartService";

export const cartHasBargainBin = (cart: Cart | undefined) =>
    cart && !!cart.cartLines && cart.cartLines.some(cartLine => !!cartLine.properties?.["lrb"]);

export const cartRequiresQuote = (cart: Cart | undefined) =>
    cart && !!cart.cartLines && cart.cartLines.some(cartLine => cartLine.pricing?.unitListPrice === 0);

export const hasQuotedItems = (cart: Cart | undefined) => {
    const rfqLines =
        cart?.cartLines?.filter(cartLine => cartLine.pricing?.unitListPrice === 0 || cartLine.quoteRequired) || [];
    return !!(rfqLines.length && rfqLines.length !== cart?.cartLines?.length);
};

export const rfqLines = (cart: Cart | undefined) =>
    cart?.cartLines?.filter(cartLine => cartLine.pricing?.unitListPrice === 0 || cartLine.quoteRequired) || [];
